import { Component as ComponentContainer } from '@styles/layout';
import { TripTypes } from '@model/common';
import { TourGroupComponent, TourDisplayType } from '@model/content';
import { TourProductGroup } from '@components/product/tour-product-tile/TourProductGroup';
import { TourGroupGrid } from './TourGroupGrid';

export const TourGroupContainer = ({
  title,
  subTitle,
  packages,
  tripType,
  path,
  hideCta,
  ctaTitle,
  ctaUrl,
  displayType
}: TourGroupComponent) => {
  if (!packages.length) {
    return;
  }

  if (displayType === TourDisplayType.GRID) {
    return <TourGroupGrid packages={packages} />;
  }
  return (
    <ComponentContainer>
      <TourProductGroup
        path={path}
        tripType={tripType || TripTypes.ESCORTED_TOURS}
        componentData={packages}
        cmsConfig={{
          title,
          subTitle,
          tours: packages,
          ctaLabel: ctaTitle,
          ctaUrl,
          hideCta
        }}
      />
    </ComponentContainer>
  );
};
